var _rect, _circle, _circle2, _rect2, _circle3, _text, _path, _path2, _path3, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanProcessPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 700",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loanProcessPanelTitle"
  }, "SalaryMates loan process") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loanProcessPanelTitle"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 500,
    height: 700,
    fill: "#0F1E2B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 150,
    r: 130,
    fill: "#7BC4E0",
    opacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 580,
    r: 110,
    fill: "#4FA0FF",
    opacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 230,
    width: 160,
    height: 160,
    rx: 36,
    fill: "#16303F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 310,
    r: 54,
    fill: "#7BC4E0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 312,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: 56,
    fontWeight: 700,
    fontFamily: "Arial, Helvetica, sans-serif",
    fill: "#0A1620"
  }, "\u20B9")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272 286 L300 258",
    stroke: "#F2F6FA",
    strokeWidth: 7,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300 258 L300 272",
    stroke: "#F2F6FA",
    strokeWidth: 7,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300 258 L286 258",
    stroke: "#F2F6FA",
    strokeWidth: 7,
    strokeLinecap: "round",
    fill: "none"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 460,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: 54,
    fontWeight: 700,
    fontFamily: "Arial, Helvetica, sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#F2F6FA"
  }, "Salary"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#7BC4E0"
  }, "Mates"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 510,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: 20,
    fontFamily: "Arial, Helvetica, sans-serif",
    fill: "#8FAFC7"
  }, "Fast salary advances, made simple")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanProcessPanel);
export default __webpack_public_path__ + "static/media/loan-process-panel.e079ef602643794cccda42156288cdee.svg";
export { ForwardRef as ReactComponent };